/**
 * ProGate — backward-compatible alias for TierGate with minTier="pro".
 * New code should use TierGate directly.
 */
import { TierGate } from './TierGate'

interface ProGateProps {
  feature: string
  children: React.ReactNode
}

export function ProGate({ feature, children }: ProGateProps) {
  return (
    <TierGate feature={feature} minTier="pro">
      {children}
    </TierGate>
  )
}
